export default __webpack_public_path__ + "static/media/ashe_card.abba991d.png";